<template>
  <b-row :class="full ? 'full-row' : 'alert-row'">
    <b-col :cols="full ? 12 : 6" class="m-auto">
      <b-alert dismissible fade :show="startTime" @dismissed="startTime=0" :variant="type" :class="full ? 'float-left' : 'float-none'">
        <p v-for="(message, index) of msg.split('<br>')" :key="index" class="mb-1">{{message}}</p>
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ['full'],
  data() {
    return {
      type: "",
      msg: "",
      startTime: 0
    }
  },
  methods: {
    showAlert(type, msg, startTime = 4) {
      this.type = type;
      this.msg = msg;
      this.startTime = startTime;
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-row {
  position: absolute;
  width: 100%;
  z-index: 2000;
}
.full-row {
  width: 100%;
}
</style>

